import { $, T } from "../../common/drupal/drupal";
/**
 * Class exemple de gestion du footer
 */
class Footer {

    /**
     * init
     */
    init() {
        // Replaces h2 in menu by another div
        const menuBlockTitle = document.querySelector('#block-menu-footer-menu');
        if(menuBlockTitle){
            let replacement = document.createElement('div');
            replacement.id = menuBlockTitle.id;
            replacement.innerHTML = menuBlockTitle.innerHTML;
            replacement.classList.add("visually-hidden");
            menuBlockTitle.parentNode.replaceChild(replacement, menuBlockTitle)
        }
    }

    /**
     * Attach.
     * @param context
     */
    attach(context) {
        if (T.contextIsRoot(context)) {
            this.init();
        }
    }
}

export let footer = new Footer();
